/* eslint-disable @typescript-eslint/naming-convention */
export enum Category {
  HELP = 1,
  MAINTENANCE = 2,
  VERSION_UPGRADE = 3,
  OTHERS = 4,
}
